import { Box, Button, TextField, Typography } from '@mui/material'
import { FormEvent, FormEventHandler, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { LinkTo } from '../components/atoms/LinkTo'
import { PasswordField } from '../components/atoms/PasswordField'
import { useApp } from '../hooks/useApp'
import { useAuth } from '../hooks/useAuth'
import { callAxios } from '../hooks/useAxios'
import { LoginResponse } from '../types/auth'

export function LoginPage(): React.ReactElement {

  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const app = useApp()
  const { login } = useAuth()
  const [password, setPassword] = useState('')

  const onSubmit: FormEventHandler<HTMLFormElement> = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const target = e.target as typeof e.target & {
      email: { value: string }
      password: { value: string }
    }
    const data = {
      email: target.email.value,
      password: target.password.value,
    }

    callAxios<LoginResponse>({
      method: 'POST',
      url: '/auth/login',
    }, { ...data, language: i18n.language }).then(async res => {
      if (res.success) {
        login(res.data)
      } else {
        app.addError(res)
      }
    })
  }

  return (
    <Box sx={{ mt: 2 }} component="form" onSubmit={onSubmit}>
      <Typography sx={{ mb: 2 }} variant="h1"><Trans>Login</Trans></Typography>
      <TextField
        margin="normal"
        color="secondary"
        variant="outlined"
        fullWidth
        data-cy="text-Login Email Address"
        label={t('Email Address')}
        name="email"
        autoComplete="email"
        autoFocus
      />
      <PasswordField
        id="login-password"
        name="password"
        label={t('Password')}
        cy="Login Password"
        color="secondary"
        autoComplete="current-password"
        value={password}
        onChange={setPassword}
      />

      <Box sx={{ mt: 2 }}>
        <LinkTo underline url="/forgot-password" title={t('Did You forget your password or did You not receive verification email?')}></LinkTo>
      </Box>

      <Box sx={{ textAlign: 'center' }}>
        <Button
          data-cy="button-Log In"
          type="submit"
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          fullWidth
        >
          <Trans>Log In</Trans>
        </Button>
      </Box>

      <Box sx={{ color: 'white', display: 'flex' }}>
        <Box sx={{ width: '45%', my: 'auto', mx: 2, borderTop: '1px solid white' }}/>
        <Box sx={{ }}><Trans>Or</Trans></Box>
        <Box sx={{ width: '45%', my: 'auto', mx: 2, borderTop: '1px solid white' }}/>
      </Box>

      <Box sx={{ textAlign: 'center' }}>
        <Button
          variant="outlined"
          sx={{ mt: 3, mb: 2 }}
          fullWidth
          onClick={() => navigate('/register')}
        >
          <Trans>Create an Account</Trans>
        </Button>
      </Box>
    </Box>
  )
}
